// FloorPlansPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const FloorPlansPage = () => <ComingSoon title="Floor plans" description="Upload and manage floor plans." />;

export default FloorPlansPage;
